module.exports = __webpack_public_path__ + "static/media/icon_menu_notify.49da2fde.svg";